import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "@/components/Layout";
import ScrollToTop from "@/components/ScrollToTop";
import { lazy, Suspense } from "react";

// Critical above-the-fold pages loaded eagerly
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import NotFound from "@/pages/not-found";

// Lazy-loaded pages for better initial bundle size
const Transportation = lazy(() => import("@/pages/Transportation"));
const Accommodation = lazy(() => import("@/pages/Accommodation"));
const Culture = lazy(() => import("@/pages/Culture"));
const Cuisine = lazy(() => import("@/pages/Cuisine"));
const PracticalInfo = lazy(() => import("@/pages/PracticalInfo"));
const AboutUs = lazy(() => import("@/pages/AboutUs"));
const Contact = lazy(() => import("@/pages/Contact"));
const BusinessDirectory = lazy(() => import("@/pages/BusinessDirectory"));
const LanguageGuide = lazy(() => import("@/pages/LanguageGuide"));
const CommunityForum = lazy(() => import("@/pages/CommunityForum"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Blog = lazy(() => import("@/pages/Blog"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const CityTemplate = lazy(() => import("./pages/CityTemplate"));
const TravelSafety = lazy(() => import("./pages/TravelSafety"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfUse = lazy(() => import("@/pages/TermsOfUse"));
const BudgetCalculator = lazy(() => import("@/pages/BudgetCalculator"));
const PackingChecklist = lazy(() => import("@/pages/PackingChecklist"));

function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#E30A17]"></div>
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <ScrollToTop />
        <Layout>
          <Suspense fallback={<PageLoader />}>
            <Switch>
              <Route path="/" component={Home} />
              <Route path="/destinations" component={Destinations} />
              <Route path="/destinations/:slug" component={CityTemplate} />
              <Route path="/transportation" component={Transportation} />
              <Route path="/accommodation" component={Accommodation} />
              <Route path="/culture" component={Culture} />
              <Route path="/cuisine" component={Cuisine} />
              <Route path="/practical-info" component={PracticalInfo} />
              <Route path="/travel-safety" component={TravelSafety} />
              <Route path="/about-us" component={AboutUs} />
              <Route path="/contact" component={Contact} />
              <Route path="/business-directory" component={BusinessDirectory} />
              <Route path="/language-guide" component={LanguageGuide} />
              <Route path="/community-forum" component={CommunityForum} />
              <Route path="/faq" component={FAQ} />
              <Route path="/blog" component={Blog} />
              <Route path="/blog/:slug" component={BlogPost} />
              <Route path="/budget-calculator" component={BudgetCalculator} />
              <Route path="/packing-checklist" component={PackingChecklist} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/terms-of-use" component={TermsOfUse} />
              <Route component={NotFound} />
            </Switch>
          </Suspense>
        </Layout>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
